import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class DeposImageService extends Service {
    constructor() {
        super();
        this.baseURL = 'product/image';
    }

    async findProductImagePath(barcode,name,type,branchId) {
        name = btoa(name); // Base64 ile encode et
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/barcode/" + barcode+  "/name/" + name+"/type/"+type + "/branchId/" + branchId, {
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }





}